import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"; 
gsap.registerPlugin(ScrollTrigger); 

export default class StickyHeader {

	constructor(el) {

		this.el = el;   

		this.headerHeight = this.el.getBoundingClientRect().top + this.el.getBoundingClientRect().height + window.scrollY;
		this.limit = this.headerHeight + 40;
		
		// let mm = gsap.matchMedia();
		// mm.add("(min-width: 768px)", () => {
			
		this.init();

		// }); 

	}

	init(){  

		let anchorsPartElm = document.querySelector('[data-hwc-anchors]');
		let anchorsLimit = 0;
		
		if(anchorsPartElm){
			anchorsLimit = anchorsPartElm.getBoundingClientRect().top + window.scrollY;		
		}

		ScrollTrigger.create({
			start		: "top top",
			end			: "bottom top",
			onUpdate	: (self) => {

				document.body.classList.remove('is-scroll-down');  
				document.body.classList.remove('is-scroll-up');  
				this.el.classList.remove('is-scroll-up');  
				this.el.classList.remove('is-scroll-down');  

				if(self.direction === -1){    
					document.body.classList.add('is-scroll-up');  
					this.el.classList.add('is-scroll-up');  
				}else{    
					document.body.classList.add('is-scroll-down');  
					this.el.classList.add('is-scroll-down');  
				} 

				if(window.scrollY > this.headerHeight && window.scrollY < this.limit){  

					document.body.classList.add('header-is-sticky');  

					gsap.set(this.el, { 
						position	:'fixed', 
						yPercent	: -100 
					}); 
							
					// if(anchorsPartElm){

					// 	gsap.set(anchorsPartElm, { 
					// 		yPercent	: 0, 
					// 		y			: 0,
					// 		force3D		: true 
					// 	}); 

					// } 

				}else if(window.scrollY > this.limit){  

					document.body.classList.add('header-is-sticky');  

					gsap.set(this.el, { 
						position	:'fixed' 
					});

					this.el.classList.add('is-sticky');  

					if(self.direction === -1){   

						gsap.set(this.el, { 
							yPercent: 0 
						});   

						// if(anchorsPartElm){
							
						// 	if(window.scrollY < anchorsLimit){
								
						// 		gsap.set(anchorsPartElm, { 
						// 			yPercent	: 0, 
						// 			y			: 0,
						// 			force3D		: false
						// 		}); 

						// 	}else{

						// 		gsap.set(anchorsPartElm, { 
						// 			yPercent	: 0, 
						// 			y			: document.querySelector('.hwc-Header').getBoundingClientRect().height,
						// 			force3D		: false
						// 		}); 
								
						// 	}
						
						// } 

					}else{   						
					
						document.body.classList.remove('header-is-sticky');  
						gsap.set(this.el, { 
							yPercent	: -100 
						});    

						// if(anchorsPartElm){
							
						// 	gsap.set(anchorsPartElm, { 
						// 		yPercent	: 0, 
						// 		y			: 0,
						// 		force3D		: false
						// 	}); 

						// } 
					}  
				
				}else{

					this.el.classList.remove('is-sticky'); 
					document.body.classList.remove('header-is-sticky');  

					gsap.set(this.el, { 
						position	:'absolute', 
						yPercent	: 0 
					});  

					// if(anchorsPartElm){
							
					// 	gsap.set(anchorsPartElm, { 
					// 		yPercent	: 0, 
					// 		y			: 0,
					// 		force3D		: false 
					// 	}); 

					// } 

				}    
			}
		});

	}  
}